/*
 * @Author: jay
 * @Date: 2021-08-23 11:21:28
 * @LastEditTime: 2021-08-26 11:00:43
 * @Description: file content
 */
import React, { useEffect } from "react";
import Header from "@/component/header";
import Footer from "@/component/footer";
import { HashRouter } from "react-router-dom";
import { BackTop, Button } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
import HocPageAuthority from "../component/HOC/HocPageAuthority";

// 判断登录域名与顺玩
// const isShunwan =
//   process.env.NODE_ENV === "development"
//     ? true
//     : location.host === "swpub.tui.shunwan.cn";
// window.isShunwan = isShunwan
// 判断登陆设备
const equipment = window.navigator.userAgent;
if (/iPhone|iPad|iPod|iOS|Android/i.test(equipment) && !window.isShunwan)
  window.location.href =
    process.env.NODE_ENV === "production"
      ? "http://m.fengbaoliu.com/#/login"
      : "http://m.pub.qcwanwan.com/#/login";

//配置主路由
const Routes: React.FC = ({ switchUserType }: any) => {
  return (
    <HashRouter>
      <Header isShunwan={window.isShunwan} />
      {switchUserType()}
      <BackTop>
        <Button icon={<ArrowUpOutlined />} />
      </BackTop>
      <Footer isShunwan={window.isShunwan} />
    </HashRouter>
  );
};

export default HocPageAuthority(Routes);
